import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getInventoryMovements } from "../../api/apiInventory";

export const useGetInventoryMovements = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["inventory-movements", params, i18next.language],
        queryFn: () => getInventoryMovements(params),
        keepPreviousData: true,
    });

    const root = data?.data;
    let movements = [];
    let meta = data?.meta;
    if (Array.isArray(root)) {
        movements = root;
    } else if (root && Array.isArray(root.data)) {
        movements = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        movements,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: movements.length },
        refetch,
    };
};
